var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalDealLostAnalyticIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.8696,
    height: 45.8696,
    rx: 5,
    fill: "#9E4545"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.126 29.6521L20.376 20.0021V21.3771L13.376 12.0271H17.1511L22.226 19.0521H21.2011L26.2511 12.0271H30.0511L23.0261 21.3771V20.0021L30.3011 29.6521H26.5011L21.1511 22.3021H22.2511L16.901 29.6521H13.126Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDealLostAnalyticIcon);
export default __webpack_public_path__ + "static/media/TotalDealLostAnalytic-Icon.b16f55fe044eb33f13b19ef7f8122397.svg";
export { ForwardRef as ReactComponent };